import React from 'react';
import MainInfoTracLayout from '../../../../components/Layout/Main';
import Content from '../../../../components/Pages/InsertManagement/Edit/Step4';

function InsertManagementEditStep4() {
  return (
    <MainInfoTracLayout className="min-h-[100vh] bg-white" isOldPage>
      <Content />
    </MainInfoTracLayout>
  );
}

export default InsertManagementEditStep4;
